import { Formik, Field } from "formik";
import MsgBoxModal from "../MsgBoxModal/msgbox-modal.component";
import Input from "../Input/input.component";
import {
	EDIT_USER,
	GET_DEPARTMENTS,
	REMOVE_USER_DEPARTMENTS,
	INSERT_USER_DEPARTMENTS,
	GET_ROLES,
	EDIT_ROLE,
	DELETE_USER_INBOXES,
	INSERT_USER_INBOXES,
	EDIT_AI_USER,
} from "./query";
import { useMutation, useQuery } from "@apollo/client";
import { useToasts } from "react-toast-notifications";
import {
	addAIUserValidationSchema,
	addUserValidationSchema,
	validateBulkAssignUserToDepartment,
} from "./validation-schema";
import MsgBoxSelect from "../MsgBoxSelect/msg-box-select.component";
import { useState } from "react";
import UserInboxSelect from "../UserInboxSelect/user-inbox-select.component";
import { AIForm, AIFormColumn, Form, FormColumn } from "./styles";
import TextArea from "../TextArea/text-area.component";

const EditAIUser = ({ isOpen, close, users, rootStore }) => {
	const inboxStore = rootStore.getInboxStore();
	const [editAIUser, { loading: editLoading, error }] =
		useMutation(EDIT_AI_USER);
	const [removeUserDepartment] = useMutation(REMOVE_USER_DEPARTMENTS);
	const [removeUserInboxes] = useMutation(DELETE_USER_INBOXES);
	const [insertUserInboxes] = useMutation(INSERT_USER_INBOXES);
	const [addUserDepartment, { loading: editDeptLoading }] = useMutation(
		INSERT_USER_DEPARTMENTS
	);
	const [editRole, { loading: editRoleLoading }] = useMutation(EDIT_ROLE);
	const { addToast } = useToasts();
	const [dirty, setDirty] = useState(false);

	const {
		data: userRoles,
		error: roleError,
		loading: roleLoading,
	} = useQuery(GET_ROLES);

	const submit = async ({ aiBotName, role, inboxes, aiPrompt }) => {
		console.log("submit clicked");
		if (inboxes.length > 0) {
			await removeUserInboxes({
				variables: {
					userId: users[0].userId,
				},
			});
			const data = inboxes.map((inbox) => ({
				UserId: users[0].userId,
				InboxId: inbox.value,
			}));
			await insertUserInboxes({
				variables: {
					inboxes: data,
				},
			});
		} else {
			await removeUserInboxes({
				variables: {
					userId: users[0].userId,
				},
			});
		}
		if (role) {
			await editRole({
				variables: {
					userId: users[0].userId,
					roleId: role.value,
				},
			});
		}
		editAIUser({
			variables: {
				userId: users[0].userId,
				aiBotName,
				aiPrompt,
			},
		});
		inboxStore.reloadPlans();
		addToast("Successfully updated user", {
			appearance: "success",
			autoDismiss: true,
		});
		closeModal();
	};

	const closeModal = () => {
		close();
		setDirty(false);
	};

	const onInputChange = (event, fn) => {
		setDirty(true);
		fn(event);
	};

	if (error) {
		console.log("err", error);
	}

	return (
		<MsgBoxModal
			aria={{
				labelledby: "heading",
				describedby: "full_description",
			}}
			isOpen={isOpen}
			cancel={closeModal}
			header="Edit AI User"
			description="Use the form below to edit AI user"
			onRequestClose={closeModal}
			submitting={editLoading || editDeptLoading || editRoleLoading}
			submit={submit}
			submitId="edit-user"
			submitButtonDisabled={dirty === false}
		>
			<div
				style={{
					overflowY: "auto",
					maxHeight: "60vh",
					paddingRight: "0.5rem",
				}}
			>
				<Formik
					initialValues={{
						aiBotName: users[0]?.firstName,
						role:
							users[0]?.role.length > 0
								? {
										label: users[0]?.role[0].Role
											.Description,
										value: users[0]?.role[0].Role.RoleId,
								  }
								: "",
						inboxes:
							users[0]?.inboxes?.length > 0
								? users[0]?.inboxes.map(({ Inbox }) => ({
										label: Inbox.Name,
										value: Inbox.InboxId,
								  }))
								: "",
						aiPrompt: users[0]?.aiPrompt,
					}}
					validateOnBlur={false}
					validateOnChange={false}
					validationSchema={addAIUserValidationSchema}
					onSubmit={(values) => {
						submit(values);
					}}
				>
					{({
						handleSubmit,
						values,
						errors,
						handleChange,
						setFieldValue,
					}) => (
						<AIForm onSubmit={handleSubmit} id="edit-user">
							<AIFormColumn>
								<Input
									placeholder="AI Name"
									required
									name="aiBotName"
									label="Name"
									onChange={(event) =>
										onInputChange(event, handleChange)
									}
									error={errors.aiBotName}
									value={values.aiBotName}
								/>

								<MsgBoxSelect
									key={3}
									placeholder="Select a role"
									name="role"
									options={userRoles.msgbox_Role.map(
										(role) => ({
											label: role.Description,
											value: role.RoleId,
										})
									)}
									onChange={(options, action) => {
										setFieldValue("role", options);
										setDirty(true);
									}}
									label="Role"
									error={errors.role}
									value={values.role}
								/>
								<UserInboxSelect
									name="inboxes"
									placeholder="Select an inbox"
									key={4}
									handleChange={(options, action) => {
										setFieldValue("inboxes", options);
										setDirty(true);
									}}
									label="Inboxes"
									hasTooltip
									toolTipText="Select the inboxes you would like this user to have access to"
									error={errors.inboxes}
									value={values.inboxes}
									rootStore={rootStore}
								/>
							</AIFormColumn>
							<AIFormColumn>
								<TextArea
									rows={16}
									style={{
										resize: "vertical",
										width: "100%",
									}}
									placeholder="Prompt"
									required
									name="aiPrompt"
									label="Prompt"
									onChange={(event) =>
										onInputChange(event, handleChange)
									}
									error={errors.aiPrompt}
									value={values.aiPrompt}
								/>
							</AIFormColumn>
						</AIForm>
					)}
				</Formik>
			</div>
		</MsgBoxModal>
	);
};

export default EditAIUser;
